export default  {
    component: 'em_param',
    name: 'em_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 3 options for module:
            - **other-sensor** 
            - **analytics**
            - **live**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **other-sensor** [Parameter Options : active_total_import_cumulative, active_total_export_cumulative, v1, v2, v3]
            - **analytics** [Parameter Options : v1, v2, v3, line_current_1, line_current_2, line_current_3, ac_power, apparent_power, reactive_power, power_factor, frequency, active_total_import_cumulative, active_total_export_cumulative]
            - **live** [Parameter Options : v1,v2,v3,ac_power,frequency,active_total_export_cumulative,active_total_import_cumulative]`
          }
    ]
  }
